import { CellContext } from '@tanstack/react-table';
import { Check } from 'lucide-react';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * Bez słów „Tak”/„Nie” — kolumna zwęża się do szerokości ikony, a „nie” i tak
 * czyta się szybciej jako brak znaku niż jako drugie słowo.
 */
export const checkboxFieldRender = <T,>(info: CellContext<T, unknown>) => {
  if (info.getValue() === true) {
    return <Check className="size-4 text-success-300" aria-label="Tak" />;
  }
  return <EmptyValue />;
};
